module.exports = __webpack_public_path__ + "img/bg-auth-layout.1435e62.png";